import angular from 'angular';
import uiRouter from 'angular-ui-router';
import notification from '../notification';
import localStorage from '../localstorage';
import subscription from '../subscription';
import config from '../config';
import service from './service';
import addressController from './address.controller';
import currencyFilter from './currency.filter';

const app = angular.module('klAccount', [
  uiRouter,
  localStorage,
  subscription,
  notification,
  config,
]);

service(app);
addressController(app);
currencyFilter(app);

export default app.name;
